(function($) {
  'use strict';

  var moveBreadcrumbs = function() {
    $('.breadcrumbs').appendTo('#nm-breadcrumbs');
    $('.breadcrumbs').show();
  };

  //move breadcrumbs if its a news and media page
  if ($('#nm-breadcrumbs').length > 0) {
    moveBreadcrumbs();
  }
}(jQuery));
